module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-ffc6a31f669a2253fa0947a0e969c579.svg";